import { render, staticRenderFns } from "./boardBalance.vue?vue&type=template&id=1f2e9d44&scoped=true&"
import script from "./boardBalance.vue?vue&type=script&lang=js&"
export * from "./boardBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e9d44",
  null
  
)

export default component.exports